import { mergeProps } from '@react-aria/utils';

import { useActionTrigger } from '@/hooks/useAction';
import { Button, ButtonProps } from '@/ui/Button';
import { cx } from '@/ui/cva';
import { Icon } from '@/ui/Icon';

type ShareButtonProps = Omit<ButtonProps, 'children'> & {
    url?: string;
};

export function ShareButton({ className, url, ...props }: ShareButtonProps) {
    const share = useActionTrigger<string>('open_share_modal');

    function handleClick() {
        share(url);
    }

    return (
        <Button
            variant="outlined"
            color="gray"
            className={cx(className, 'test aspect-1 rounded-full p-0 text-xl')}
            {...mergeProps(props, {
                onClick: handleClick,
            })}
        >
            <Icon>share</Icon>
        </Button>
    );
}
